import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDotCircle} from "@fortawesome/free-solid-svg-icons";

const PageTitle = ({title, icon, color}) => {
    return <div className='flex items-center flex-1 mb-10'>
        {
            icon !== null ? <FontAwesomeIcon icon={icon} color={color} size='2x' className='ml-3'/> : ''
        }
        <h1 className={`text-3xl text-${color}`}>{title}</h1>
    </div>;
}

export default PageTitle;